<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">{{ $route.meta.label }}  
        <div class="card-header-actions">
          <!-- <button class="btn btn-primary mr-1" @click="showPrintConfirm=true">
              <i class="fa fa-print"></i> Print
          </button> -->
         <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>      
      <b-row >
        <b-col lg="4">
            <b-input-group >
              <b-input-group-prepend><span class="p-2">Saldo s.d. Tanggal</span></b-input-group-prepend>
              <b-form-input v-model="model.tgl2" :state="!$v.model.tgl2.$error" type="date"></b-form-input>
            </b-input-group>
        </b-col>
        <b-col lg="5">
            <b-input-group >
              <b-form-checkbox class="ml-1 mt-2 text-left" v-model="model.excludezero" value=1 unchecked-value=0 >Sembunyikan Tunggakkan NOL</b-form-checkbox>
              <b-input-group-append><b-button class="ml-3 btn btn-success" @click="getData()" > <i class="fa fa-play"></i> Process</b-button></b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body v-show="showSummary" >
          <div class="p-2 bg-info text-white font-weight-bolder mb-1">REKAP per KARYAWAN per NO_PINJAMAN</div>        
            <b-row v-if="(filterShow=='Hide')">
                <b-col lg="6">
                    <b-form-group
                        label="Filter"
                        label-cols-sm="1"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            v-model="filter"
                            type="search"
                            id="filterInput"
                            placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>            
                </b-col>         
                <b-col lg="6">
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                </b-col>         
            </b-row>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="aging.rekap"
                :fields="tblOri.fields"
                :current-page="tblOri.page"
                :per-page="tblOri.limit"
                :sort-by.sync="tblOri.sortBy"
                :sort-desc.sync="tblOri.sortDesc"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
                <template v-slot:cell(totalOri)="data">
                    {{ data.item.totalOri | numFormat }}
                </template>
                <template v-slot:cell(ar_amount)="data">
                    {{ data.item.ar_amount | numFormat }}
                </template>
                <template v-slot:cell(ar_outstand)="data">
                    {{ data.item.ar_outstand | numFormat }}
                </template>
                <template v-slot:cell(ar_outstand_undue)="data">
                    {{ data.item.ar_outstand_undue | numFormat }}
                </template>
                <template v-slot:cell(latestPaym)="data">
                  <span v-if="data.item.latestPaym">{{data.item.latestPaym | moment("DD MMM YYYY")}}</span>
                </template>
                <template v-slot:cell(next_installment_due_no)="data">
                  Sisa Angsuran {{data.item.jmlAngsuranSisa}}Bln, menunggak {{data.item.jmlAngsuranDue}}Bln No.{{data.item.next_installment_no}}
                  <span v-if="(data.item.jmlAngsuranDue>1)">
                      sd {{data.item.next_installment_due_no}}
                  </span>
                </template>
                          

                <template v-slot:head(aging1Ori)="data">
                  <span v-if="(aging.seting.arAge1)" class="text-info">BLN BERJALAN</span>
                  <span v-else class="text-info">BLN BERJALAN</span>
                </template>
                <template v-slot:cell(aging1Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,1)">
                      {{ data.item.aging1Ori | numFormat }}
                  </a>                    
                </template>
                <template v-slot:head(aging2Ori)="data">
                  <span v-if="(aging.seting.arAge2)" class="text-info"> > {{aging.seting.arAge2-aging.seting.arAge1}} hari</span>
                  <span v-else class="text-info"> > 30 hari</span>
                </template>
                <template v-slot:cell(aging2Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,2)">
                      {{ data.item.aging2Ori | numFormat }}
                  </a>                    
                </template>
                <template v-slot:head(aging3Ori)="data">
                  <span v-if="(aging.seting.arAge3)" class="text-info"> > {{aging.seting.arAge3-aging.seting.arAge1}} hari</span>
                  <span v-else class="text-info"> > 60 hari</span>
                </template>
                <template v-slot:cell(aging3Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,3)">
                      {{ data.item.aging3Ori | numFormat }}
                  </a>                    
                </template>
                <template v-slot:head(aging4Ori)="data">
                  <span v-if="(aging.seting.arAge4)" class="text-info"> > {{aging.seting.arAge4-aging.seting.arAge1}} hari</span>
                  <span v-else class="text-info"> > 90 hari</span>
                </template>
                <template v-slot:cell(aging4Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,4)">
                      {{ data.item.aging4Ori | numFormat }}
                  </a>                    
                </template>
                <template v-slot:head(aging5Ori)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info"> > {{aging.seting.arAge5-aging.seting.arAge1}} hari</span>
                  <span v-else class="text-info"> > 120 hari</span>
                </template>
                <template v-slot:cell(aging5Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,5)">
                      {{ data.item.aging5Ori | numFormat }}
                  </a>                    
                </template>

                <template v-slot:head(aging6Ori)="data">
                  <span v-if="(aging.seting.arAge5)" class="text-info"> > {{aging.seting.arAge5-aging.seting.arAge1}} hari</span>
                  <span v-else class="text-info"> > 180 hari</span>
                </template>
                <template v-slot:cell(aging6Ori)="data">
                  <a href="javascript:void(0)" @click.stop="getDetail(data.item,6)">
                      {{ data.item.aging6Ori | numFormat }}
                  </a>                    
                </template>
              <template v-slot:custom-foot="data">
                <b-tr>
                  <b-td class="font-weight-bolder text-right" colspan="3"> TOTAL  : &nbsp;</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.ar_outstand | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.ar_outstand_undue | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.totalOri | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.aging1Ori | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.aging2Ori | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.aging3Ori | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.aging4Ori | numFormat}}</b-td>
                  <b-td class="font-weight-bolder text-right">{{aging.aging5Ori | numFormat}}</b-td>
                </b-tr>
              </template>
            </b-table>
            <b-row class="mt-2">
                <b-col cols="3">
                    <b-form-radio-group  v-model="showSummary" class="ml-1">
                      <b-form-radio :value="true">Rekap </b-form-radio>
                      <b-form-radio :value="false">Detail </b-form-radio>
                        <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                          <b> {{ filterShow }}</b> Filter
                        </b-form-checkbox>
                    </b-form-radio-group>
                </b-col>
                <b-col cols="9">
                    <b-row >
                      <b-col cols="6" >
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-1">Limit per Page</span></b-input-group-prepend>
                            <b-form-input v-model="limit" type="number" class="ml-1 mr-2" v-b-tooltip.hover :title="`${limit} records`" size="sm" style="max-width:80px; !important;"></b-form-input>  
                            <b-input-group-append>
                              <span v-if="((tblOri.page * tblOri.limit)>tblOri.total)" class="pt-2">
                                Showing {{(tblOri.page - 1) * tblOri.limit + 1}} to {{tblOri.total}} of {{tblOri.total}} entries
                              </span>
                              <span v-else class="pt-1">
                                Showing {{(tblOri.page - 1) * tblOri.limit + 1}} to {{tblOri.page * tblOri.limit}} of {{tblOri.total}} entries
                              </span>
                            </b-input-group-append>
                        </b-input-group>
                      </b-col>
                      <b-col cols="6">            
                        <b-pagination 
                          align="right"
                          :total-rows="tblOri.total"
                          :per-page="tblOri.limit"
                          v-model="tblOri.page"
                        ></b-pagination>
                      </b-col>
                    </b-row>
                </b-col>
            </b-row>
      </b-card>
      <b-card no-body v-if="!showSummary">
        <div class="p-2 bg-dark text-white font-weight-bolder">DETAIL per KARYAWAN per NO_PINJAMAN</div>        
        <b-table
          class="mb-0"
          ref="tableDtl"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          bordered
          style="font-size:smaller;"
          :items="agingDtl.list"
          :fields="tblDtl.fields"
          :current-page="tblDtl.page"
          :per-page="tblDtl.limit"
          :sort-by.sync="tblDtl.sortBy"
          :sort-desc.sync="tblDtl.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          show-empty
        >
          <template v-slot:cell(nomor)="data">
            {{ (tblDtl.page - 1) * tblDtl.limit + (data.index + 1)}}
          </template>
          <template v-slot:cell(angsuranDue)="data">
            ke-{{data.item.angsuranNo}}. {{data.item.angsuranDue | moment("DD MMM YYYY")}}
          </template>
          <template v-slot:cell(jumlah)="data">
            {{data.item.jumlah | numFormat}}
          </template>
          <template v-slot:cell(angsuranOutstand)="data">
            {{data.item.angsuranOutstand | numFormat}}
          </template>
          <template v-slot:cell(angsuranAmount)="data">
            {{data.item.angsuranAmount | numFormat}}
          </template>
          <template v-slot:cell(nilai_pokok)="data">
            {{data.item.nilai_pokok | numFormat}}
          </template>
        <template v-slot:cell(nilai_bunga)="data">
          {{data.item.nilai_bunga | numFormat}}
        </template>
        <template v-slot:cell(bunga_tarifthn)="data">
          {{data.item.bunga_tarifthn | numFormat}}% 
        </template>
        <template v-slot:cell(tenor)="data">
          {{data.item.tenor | numFormat}}Bln
        </template>
        <template v-slot:cell(aging)="data">
          <span v-if="(data.item.aging !=0)">{{data.item.aging}} hari</span>
        </template>

          <template v-slot:empty="scope">
            <h6 class="text-center">{{ scope.emptyText }}</h6>
          </template>
          <template v-slot:emptyfiltered="scope">
            <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
          </template>
          <template v-slot:custom-foot="data">
            <b-tr>
              <b-td class="font-weight-bolder text-right" colspan="11">SUB TOTAL : &nbsp;</b-td>
              <b-td class="font-weight-bolder text-right">{{agingDtl.angsuranOutstand | numFormat}}</b-td>
              <b-td class="font-weight-bolder text-right">{{agingDtl.angsuranAmount | numFormat}}</b-td>
              <b-td class="font-weight-bolder text-right">{{agingDtl.nilai_pokok | numFormat}}</b-td>
              <b-td class="font-weight-bolder text-right">{{agingDtl.nilai_bunga | numFormat}}</b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="3">
              <b-form-radio-group  v-model="showSummary" class="ml-1">
                <b-form-radio :value="true">Rekap </b-form-radio>
                <b-form-radio :value="false">Detail </b-form-radio>
                  <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch class="ml-2">
                    <b> {{ filterShow }}</b> Filter
                  </b-form-checkbox>
              </b-form-radio-group>
          </b-col>
          <b-col cols="9">
              <b-row >
                <b-col cols="6" >
                  <b-input-group>
                      <b-input-group-prepend><span class="pt-1">Limit per Page</span></b-input-group-prepend>
                      <b-form-input v-model="limitDtl" type="number" class="ml-1 mr-2" v-b-tooltip.hover :title="`${limitDtl} records`" size="sm" style="max-width:80px; !important;"></b-form-input>  
                      <b-input-group-append>
                        <span v-if="((tblDtl.page * tblDtl.limit)>tblDtl.total)" class="pt-2">
                          Showing {{(tblDtl.page - 1) * tblDtl.limit + 1}} to {{tblDtl.total}} of {{tblDtl.total}} entries
                        </span>
                        <span v-else class="pt-1">
                          Showing {{(tblDtl.page - 1) * tblDtl.limit + 1}} to {{tblDtl.page * tblDtl.limit}} of {{tblDtl.total}} entries
                        </span>
                      </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col cols="6">            
                  <b-pagination 
                    align="right"
                    :total-rows="tblDtl.total"
                    :per-page="tblDtl.limit"
                    v-model="tblDtl.page"
                  ></b-pagination>
                </b-col>
              </b-row>
          </b-col>
      </b-row>

      </b-card>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <!-- <b-modal v-model="showPrintConfirm" title="Print Choices" size="sm"  @ok="print">
      <b-form-radio-group id="chkPrint" name="printMenus" v-model="model.view" stacked>
        <b-form-radio value="Summary in Original Currency">Rekap per Siswa per Jenis Bayaran</b-form-radio>
        <b-form-radio value="Detail Invoice Outstanding">Detail Tunggakan per Siswa per Jenis Bayaran</b-form-radio>
      </b-form-radio-group>
    </b-modal> -->
  </div>
</template>


<script>
import moment from 'moment';
import crud from "../../apis/crud";
import loan from "../../apis/loan";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        tgl2: { required },
    },
  }, 
  data() {
    return {
      horizontal: true,
      isLoading:false,
      showSummary:true,
      showPrintConfirm:false,
      showReport:false,
      reportUrl: null,
      model: {modeGet:'view', tabIndex:0, sekolahKey:'', jnBayarKey:'',tgl1:'',tgl2:'', exclude:0, excludezero:1},
      uanguser: this.$store.state.user.matauang,
      aging : {rekap:[], detail:[], seting:{}},
      agingDtl: {list:[], outstand: 0, ar_amount: 0},
      subtotal : {},
      limit: 15,
      tblOri: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "crewnik",
            label: "No. Karyawan",
            sortable: true
          },
          {
            key: "crewname",
            label: "Nama Karyawan",
            sortable: true
          },
          {
            key: "pinjamanNo",
            label: "Nomor Pinjaman",
            sortable: true
          },
          {
            key: "ar_amount",
            label: "Total (AR) Piutang",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ar_outstand_undue",
            label: "AR belum Jt.tempo",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "totalOri",
            label: "AR Jt.Tempo",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging1Ori",
            label: "Outstanding",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging2Ori",
            label: "Outstanding",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging3Ori",
            label: "Outstanding",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging4Ori",
            label: "Outstanding",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "aging5Ori",
            label: " > 180 hari",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "latestPaym",
            label: "Terakhir Bayar",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "next_installment_due_no",
            label: "Angsuran Jt.tempo",
          },

        ]
      },
      filter: null,
      filterOn: ['crewnik','crewname','perusahaanNama'],   
      filterShow:'Show',   
      limitDtl:15,      
      tblDtl: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "nomor",
            label: "No.",
            thStyle: "width:40px",
            sortable: true
          },
          {
            key: "crewnik",
            label: "No. Karyawan",
            thStyle: "width:120px",
            sortable: true
          },
          {
            key: "crewname",
            label: "Nama Karyawan",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "pinjamanNo",
            label: "No. Pinjaman",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "uraian",
            label: "Penggunan Pinjaman",
            thClass: "text-center",
          },
        {
          key: "jumlah",
          label: "Pokok Pinjaman",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "tenor",
          label: "Tenor",
          thStyle: "width:80px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
          {
            key: "angsuranDue",
            label: "Jadwal Angsuran",
            thStyle: "width:150px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "angsuranNo",
            label: "Angsuran ke-",
            thStyle: "width:70px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "aging",
            label: "Jt.Tempo",
            thStyle: "width:50px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "angsuranOutstand",
            label: "Angsuran Jt.Tempo",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "angsuranAmount",
            label: "Angsuran belum Jt.Tempo",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ]
      },
      optSekolahan: [],
      optJnBayar: [],
      optJenjang: [{value:'',text:'--semua--'}],

    };
  },
  components: { Loading},
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblOri.limit=newVal;
        }
      }, 500);
    },    
    "model.jnBayarKey": function(newval) {
      const obj=this.optJnBayar.find(d => d.value === newval);
        this.model.namaacc=obj.text || '';
        this.model.kodeacc=obj.kodeacc;
    },
  },  
  created: async function(){
    console.log('route.params: ', this.$route.params.tgl2);
    // if (this.$route.params.tgl1 && this.$route.params.tgl2 && this.$route.params.kodeaw) {
    if (this.$route.params.tgl2) {
        // this.model.kodeaw = this.$route.params.kodeaw;
        // this.model.kodeak = this.$route.params.kodeak || this.model.kodeaw;
       this.model.tgl2=this.$route.params.tgl2;
       this.getData();
    } else {
        const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.model.tgl1=this.$store.state.user.tglaktif;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
    }
  },  
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblOri.total = filteredItems.length;
      this.tblOri.page = 1;
      this.tblOri.total = filteredItems.length;
      this.tblOri.page = 1;
    },  
    getData: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.showSummary=true;
        this.isLoading=true;
        this.model.modeGet = 'view';
        const result = await loan.aging(this.model);
        this.isLoading=false;      
        if (result.success) {
            this.aging.rekap = result.rekap;
            this.aging.detail = result.detail;
            this.aging.pinjaman = result.pinjaman;
            this.aging.seting = result.setingan;
            this.aging.ar_outstand = 0;
            this.aging.ar_outstand_undue = 0;
            this.aging.totalOri = 0;
            this.aging.aging1Ori = 0;
            this.aging.aging2Ori = 0;
            this.aging.aging3Ori = 0;
            this.aging.aging4Ori = 0;
            this.aging.aging5Ori = 0;
            this.aging.rekap.forEach((ap) => {
              this.aging.ar_outstand += ap.ar_outstand;
              this.aging.ar_outstand_undue += ap.ar_outstand_undue;
              this.aging.totalOri += ap.totalOri;
              this.aging.aging1Ori += ap.aging1Ori;
              this.aging.aging2Ori += ap.aging2Ori;
              this.aging.aging3Ori += ap.aging3Ori;
              this.aging.aging4Ori += ap.aging4Ori;
              this.aging.aging5Ori += ap.aging5Ori;
          });
          
          this.tblOri.total= this.aging.rekap.length;
          if (result.message) toastr.warn(result.message,'WARNING',10000);
        } else {
          if (result.message) toastr.error(result.message,'ERROR',10000);
        }
       }
    },
    getDetail: function (row, col) {
      const setingan = this.aging.seting;
      if ((row.crewnik) && ((row.totalOri) != 0)) {
          let pesan = `Tampilkan Detail Tunggakan  a.n: ${row.crewnik.trim()} | ${row.crewname.trim()}`;
          console.log('anging detail col: ', col)
          switch (col) {
              case 0:
                  pesan = pesan;
                  break;
              case 1:
                  pesan = pesan + '" Aging : ' + setingan['arAge' + col] + ' hari';
                  break;
              case 2:
                  pesan = pesan + '" Aging : ' + setingan['arAge' + col] + ' hari';
                  break;
              case 3:
                  pesan = pesan + '" Aging : ' + setingan['arAge' + col] + ' hari';
                  break;
              case 4:
                  pesan = pesan + '" Aging : ' + setingan['arAge' + col] + ' hari';
                  break;
              case 5:
                  pesan = pesan + '" Aging > ' + setingan['arAge' + col] + ' hari';
                  break;
          }
         toastr.info(pesan);
         this.isLoading=true;
          this.agingDtl.list = [];
          this.agingDtl.angsuranOutstand =  0;
          this.agingDtl.angsuranAmount =0;
          this.agingDtl.nilai_pokok =0;
          this.agingDtl.nilai_bunga =0;
          const lines = this.aging.detail.filter( d => (d.crewnik == row.crewnik && d.pinjamanNo == row.pinjamanNo));
          switch (col) {
              case 0:
                  lines.forEach((trx) => {
                      this.agingDtl.list.push(trx);
                      this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                      this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                      this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                      this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                  });
                  break;
              case 1:
                  lines.forEach((trx) => {
                      if (trx.aging <= setingan['arAge1']) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;
              case 2:
                  lines.forEach((trx) => {
                      if ((trx.aging > setingan['arAge1']) && (trx.aging <= setingan['arAge2'])) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;
              case 3:
                  lines.forEach((trx) => {
                      if ((trx.aging > setingan['arAge2']) && (trx.aging <= setingan['arAge3'])) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;
              case 4:
                  lines.forEach((trx) => {
                      if ((trx.aging > setingan['arAge3']) && (trx.aging <= setingan['arAge4'])) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;
              case 5:
                  lines.forEach((trx) => {
                      if ((trx.aging > setingan['arAge4']) && (trx.aging <= setingan['arAge5'])) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;
              case 6:
                  lines.forEach((trx) => {
                      if (trx.aging > setingan['arAge5']) {
                          this.agingDtl.list.push(trx);
                          this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
                          this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
                          this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
                          this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
                      }
                  });
                  break;

          }
          // lines.forEach((trx) => {
          //         this.agingDtl.list.push(trx);
          //         this.agingDtl.angsuranOutstand +=  trx.angsuranOutstand;
          //         this.agingDtl.angsuranAmount +=  trx.angsuranAmount;
          //         this.agingDtl.nilai_pokok +=  trx.nilai_pokok;
          //         this.agingDtl.nilai_bunga +=  trx.nilai_bunga;
          // });
          this.showSummary=false;
         this.isLoading=false;          
      }
    },

    // confirmAction: function() {
    //     toastr.info('Klik Pada TRX. NUMBER untuk PRINT VOUCHER');
    // },
    exportxls: async function() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
      } else {
        this.isLoading=true;
        try {
            this.model.modeGet = 'exportXls';
            const response = await loan.aging(this.model);
            this.isLoading=false;    
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `piutang_pinjaman${moment().format("YYYYMMMDD")}.xlsx`);
          document.body.appendChild(link);
          link.click();

        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR',10000);
            }
        }
      }
    },  
    // print: async function()
    // {
    //   this.isLoading=true;
    //   try {
    //             this.showReport=true;
    //       this.reportUrl= await loan.agingprint(this.model);
    //       this.isLoading=false;
    //           `;
    //           }
    //   } catch (error) {
    //       this.isLoading=false;
    //       if (error.message) {
    //           toastr.error(error.message,'ERROR',10000);
    //       } else {
    //           toastr.error(JSON.stringify(error),'ERROR',10000);
    //       }
    //   }
    // },    
    close(){
      if (this.showSummary===true ) {
          router.push("home");
      } else {
        this.showSummary=true;
      }

    }
  }
};
</script>
